<template>
  <el-drawer :with-header="false" :wrapper-closable="false" :visible.sync="gameStatusDrawer" size="700px">
    <div class="drawer-header">
      <span>{{ title }}</span>
      <el-button class="icon-butn" size="small" title="刷新" style="padding: 9px;border-radius: 8px;" @click="refresh">
        <svg-icon icon-class="refresh" />
      </el-button>
    </div>

    <div class="all-blcok">
      <div v-if="statusList && statusList.length == 0" style="padding-left: 50px;color: #999;">
        <span>暂无流程</span>
      </div>
      <div v-for="(status, index) in statusList" :key="index" class="status-block" :style="{'border': index == statusList.length -1 ? 'none' : ''}">
        <svg-icon class="status-svg" :icon-class="status.stepStatus == 0 ? 'game_resolve' : status.stepStatus == 1 ? 'game_reject' : 'game_load'" style="width:16px;height:16px;" />
        <div style="margin-left: 20px;">
          <p class="status-title">{{ status.processTitle }}
            <!-- 已拒绝文字 -->
            <span v-if="status.stepStatus == 1" style="color: red; margin-left: 18px;">已拒绝</span>

            <!-- 点击查看详细流程内容 -->
            <el-popover v-if="status.child" popper-class="status-popover" placement="right" width="300" trigger="click">
              <div v-for="(statusChild, indexChild) in status.child" :key="indexChild" class="status-block" :style="{'border': indexChild == status.child.length -1 ? 'none' : '', 'padding': indexChild == status.child.length -1 ? '0' : '', 'margin-left': '20px'}">
                <svg-icon class="status-svg" :icon-class="statusChild.stepStatus == 0 ? 'game_resolve' : statusChild.stepStatus == 1 ? 'game_reject' : 'game_load'" style="width:16px;height:16px;" />
                <div style="margin-left: 20px;">
                  <p class="status-title">{{ statusChild.processTitle }}</p>
                  <!-- <span class="status-text">创建人:{{ statusChild.processUser }}</span> -->
                  <span style="color: #666666;line-height: 20px;font-size: 14px;">{{ statusChild.processTime }}</span>
                </div>
              </div>
              <span slot="reference" class="detail-content">点击查看详细流程内容 ></span>
            </el-popover>
          </p>
          <span v-if="status.processUser" class="status-text">操作人:{{ status.processUser }}</span>
          <span style="color: #666666;line-height: 20px;font-size: 14px;">{{ status.processTime }}</span>
          <div v-if="status.showMessage" class="status-opinion">{{ status.processMessage }}</div>
        </div>
      </div>
    </div>

    <el-button class="footer" plain type="primary" @click="closeDrawer">关闭</el-button>

  </el-drawer>
</template>

<script>
import { detail_audit } from '@Sys~/api/sys'

export default {
  data() {
    return {
      gameStatusDrawer: false,
      statusList: [],
      row: {},
      title: '审核流程'
    }
  },

  methods: {
    // 初始化
    init(row) {
      console.log(row)
      this.row = row
      this.title = row.auditStatus == 3 ? '审核游戏-分析师审核' : row.auditStatus == 5 ? '审核游戏-大数据审核' : row.auditStatus == 4 ? '审核游戏-服务端审核' : '审核流程'
      this.gameStatusDrawer = true
      this.getList()
    },

    // 获取流程列表
    getList() {
      detail_audit({ appkey: this.row.appkey, stage: this.row.auditStatus }).then(res => {
        if (res.code == 1) {
          this.statusList = res.data
        }
      })
    },

    // 刷新
    refresh() {
      this.$message({
        message: '刷新成功',
        type: 'success'
      })
      this.getList()
    },

    closeDrawer() {
      this.gameStatusDrawer = false
    }
  }
}
</script>
<style lang="scss">

.drawer-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  color: #333333;
  font-weight: 600;
  font-size: 18px;
}
.el-drawer__body{
  overflow: auto;
}

.all-blcok, .status-popover{
  // padding: 0px 20px;
  // margin-left: 32px;
  // border-left: 1px solid #E5E5E5;
  // position: relative;
  max-height: 600px;
  overflow: auto;
  margin-top: 18px;
  .status-block{
    position: relative;
    padding: 0px 0px 32px 0px;
    margin-left: 32px;
    border-left: 1px solid #E5E5E5;
    .status-svg{
      position: absolute;
      left: -8px;
    }
    .status-title{
      color: #333333;
      line-height: 20px;
      margin-bottom: 4px;
      margin: 0px 0px 4px 0px;
      font-size: 14px;
    }
    .status-text{
      line-height: 20px;
      color: #666;
      font-size: 14px;
      margin-right: 16px;
    }
    .status-opinion{
      margin-top: 8px;
      padding: 8px 12px;
      border: 1px solid #E5E5E5;
      background: #F9F9F9;
      color: #333333;
      font-size: 12px;
      width: 80%;
      height: 60px;
      overflow: auto;
    }
  }

  .detail-content{
    margin-left: 18px;
    cursor: pointer;
    color: #3a89ff;
  }
}
.footer{
  position: absolute;
  right: 25px;
  bottom: 25px;
}
</style>

